.root {
  align-items: center;
  display: flex;
  gap: 8px;
  width: 100%;
}

.root-is-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.field {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  color: var(--color-text);
  font-size: 14px;
  height: 40px;
  padding: 0 12px;
}

.date {
  flex: 1 1 auto;
}

.time {
  flex: 0 0 auto;
  width: 120px;
}
